import ActivityContent from './ActivityContent';

export default ActivityContent;
